import React from 'react';
import { Grid, TextField, FormControlLabel, Checkbox, Typography, Divider, Autocomplete, MenuItem } from '@mui/material';
import { effortToleranceOptions, dentitionOptions } from '../constants/options';

const HistoryAndAirwaySection = ({ formData, handleChange, setFormData }) => {
  return (
    <>
      <Typography variant="h6">PAST HISTORY</Typography>
      <Grid container spacing={2}>
        <Grid item xs={6} md={4}>
          <FormControlLabel control={<Checkbox checked={formData.previous_hospitalization || false} onChange={handleChange("previous_hospitalization")} />} label="Previous Hospitalization" />
        </Grid>
        <Grid item xs={6} md={4}>
          <FormControlLabel control={<Checkbox checked={formData.previous_surgery_anesthesia || false} onChange={handleChange("previous_surgery_anesthesia")} />} label="Previous Surgery/Anesthesia" />
        </Grid>
        <Grid item xs={6} md={4}>
          <FormControlLabel control={<Checkbox checked={formData.drug_allergy || false} onChange={handleChange("drug_allergy")} />} label="Drug Allergy" />
        </Grid>
      </Grid>

      <Divider sx={{ my: 2 }} />

      <Typography variant="h6">PERSONAL HISTORY</Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={6} md={3}>
          <FormControlLabel control={<Checkbox checked={formData.smoking || false} onChange={handleChange("smoking")} />} label="Smoking" />
        </Grid>
        <Grid item xs={6} md={3}>
          <FormControlLabel control={<Checkbox checked={formData.substance_abuse || false} onChange={handleChange("substance_abuse")} />} label="Substance Abuse" />
        </Grid>
        <Grid item xs={6} md={3}>
          <FormControlLabel control={<Checkbox checked={formData.alcoholism || false} onChange={handleChange("alcoholism")} />} label="Alcoholism" />
        </Grid>
        <Grid item xs={6} md={3}>
          <FormControlLabel control={<Checkbox checked={formData.pregnancy_lactation || false} onChange={handleChange("pregnancy_lactation")} />} label="Pregnancy/Lactation" />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField 
            value={formData.breath_holding_time || ''} 
            onChange={handleChange("breath_holding_time")} 
            label="Breath Holding Time" 
            variant="outlined" 
            fullWidth 
            type="time" 
            InputLabelProps={{ shrink: true }} 
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={effortToleranceOptions}
            value={formData.effort_tolerance || ''}
            onInputChange={(event, newValue) => setFormData(prev => ({ ...prev, effort_tolerance: newValue }))}
            renderInput={(params) => <TextField {...params} label="Effort Tolerance" variant="outlined" fullWidth />}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField value={formData.personal_history_others || ''} onChange={handleChange("personal_history_others")} label="Others" variant="outlined" fullWidth />
        </Grid>
      </Grid>

      <Divider sx={{ my: 2 }} />

      <Typography variant="h6">Airway Assessment</Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField select fullWidth label="MPC" value={formData.mpc || ''} onChange={handleChange("mpc")} name="mpc">
            {['I', 'II', 'III', 'IV'].map((option) => (
              <MenuItem key={option} value={option}>{option}</MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField select fullWidth label="MO" value={formData.mo || ''} onChange={handleChange("mo")}>
            {['<2FB', '>2FB'].map((option) => (
              <MenuItem key={option} value={option}>{option}</MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField select fullWidth label="Neck Movement" value={formData.neck_movement || ''} onChange={handleChange("neck_movement")}>
            {['N', "Restricted"].map((option) => (
              <MenuItem key={option} value={option}>{option}</MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField select fullWidth label="Mento-Hyoid distance" value={formData.mento_hyoid_distance || ''} onChange={handleChange("mento_hyoid_distance")}>
            {[">4cm", "<4cm"].map((option) => (
              <MenuItem key={option} value={option}>{option}</MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <Autocomplete
            freeSolo
            options={dentitionOptions}
            value={formData.dentition || ''}
            onInputChange={(event, newValue) => setFormData(prev => ({ ...prev, dentition: newValue }))}
            renderInput={(params) => <TextField {...params} label="Dentition" variant="outlined" fullWidth />}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField fullWidth label="Others" value={formData.airway_assessment_others || ''} onChange={handleChange("airway_assessment_others")} />
        </Grid>
      </Grid>
    </>
  );
};

export default HistoryAndAirwaySection;
